import React from 'react';
import { Container, Grid, Typography, Box } from '@mui/material';
import { useAuth } from 'src/context/auth/AuthContext';
import Page from 'src/components/Page';

import { 
  TransactionStatusTracker,
  StudentEngagementReport,
  TeacherTransactionManager 
} from 'src/components/teacher';

export default function TransactionManagement() {
  const { user } = useAuth();
  const teacherId = user?.id || '';

  return (
    <Page title="Transaction Management">
      <Container maxWidth="xl">
        <Box mb={4}>
          <Typography variant="h3" fontWeight="bold" gutterBottom>
            Transaction Management Dashboard
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Monitor student transactions, track engagement, and manage overrides.
          </Typography>
        </Box>

        <Grid container spacing={3}>
          {/* Transaction Status Tracker - Full Width */}
          <Grid item xs={12}>
            <TransactionStatusTracker teacherId={teacherId} />
          </Grid>

          {/* Enhanced Transaction Manager - Full Width */}
          <Grid item xs={12}>
            <TeacherTransactionManager teacherId={teacherId} />
          </Grid>

          {/* Student Engagement Report - Full Width */}
          <Grid item xs={12}>
            <StudentEngagementReport teacherId={teacherId} />
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
}